import React, {useContext} from 'react';
import {Link, NavLink} from "react-router-dom";
import logo from '../../assets/images/colzones-logo-256px.png'
import {MapContext} from "../../context/MapContext";

const Navigation = () => {
    const {mapContext} = useContext(MapContext);

    return (
        <>
            <nav id={"navigation"} className="navbar navbar-expand-md navbar-dark navbar-custom">
                <Link to="/" className="brand-logo d-none d-md-block"><img src={logo} alt={'Colzones'}/></Link>
                <div className=" d-none d-lg-block" id="navbarNavDropdown">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink to="/" className="nav-link"><i className="fa fa-home"/>Accueil</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/carte"
                                     className={`nav-link ${(mapContext && !mapContext.dockyardData) && 'nav-link-disabled'}`}>
                                <i className="fa fa-map"/>Carte</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/a-propos" className="nav-link"><i className="fa fa-map"/>A Propos</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="d-lg-none fixed-bottom" id="navbar-menu-min">
                    <div>
                        <NavLink to="/" className="nav-link"> <i className="fa fa-home"/></NavLink>
                    </div>
                    <div>
                        <NavLink to="/carte" className={`nav-link ${(mapContext && !mapContext.dockyardData) && 'nav-link-disabled'}`}>
                            <i className="fa fa-map"/>
                        </NavLink>
                    </div>
                    <div>
                        <NavLink to="/a-propos" className="nav-link"> <i className="fa fa-question"/></NavLink>
                    </div>
                </div>
            </nav>
        </>

    )
        ;
};

export default Navigation;